import { render, staticRenderFns } from "./InfosCatalogue.vue?vue&type=template&id=1a9524ec"
import script from "./InfosCatalogue.vue?vue&type=script&lang=js"
export * from "./InfosCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports